import React from 'react'
import { useTranslation } from 'react-i18next'

const LanguageSwitcher: React.FC = () => {
  const { t, i18n } = useTranslation()

  const languages = [
    { code: 'en', label: t('lang.en') },
    { code: 'zh-Hans', label: t('lang.zhHans') },
    { code: 'zh-Hant', label: t('lang.zhHant') },
  ]

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value)
  }

  return (
    <select
      value={i18n.language}
      onChange={handleChange}
      className="text-sm border border-border rounded-lg px-3 py-1.5 bg-white focus:outline-none focus:border-primary cursor-pointer"
    >
      {languages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  )
}

export default LanguageSwitcher
